import React from "react";
import { useParams } from "react-router-dom";
import RootShortcutPortfolioUsername from "container/shortcutPortfolio/RootShortcutPortfolioUsername";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";

function ShortcutPortfolioUsernamePage(props) {
  const params = useParams();

  return (
    <AppUpdateCheckpoint>
      <RootShortcutPortfolioUsername username={params.name} />
    </AppUpdateCheckpoint>
  );
}

export default ShortcutPortfolioUsernamePage;
